import { all } from 'redux-saga/effects';
import popupSagas from './popup.sagas';
import { sagas as sharedSagas } from '@innovyze/stylovyze';

export default function* rootSaga() {
	yield all([sharedSagas, ...popupSagas]);
}
